import React from 'react';
import { cx } from './cx';

interface TableProps extends React.TableHTMLAttributes<HTMLTableElement> {
  /** Accessible name; also shown to screen readers as the caption. */
  caption?: string;
  /** Keeps the header row visible when the wrapper scrolls (set a max height on the wrapper). */
  stickyHeader?: boolean;
  /** Ref to the scroll wrapper, for infinite-scroll handlers. */
  wrapRef?: React.Ref<HTMLDivElement>;
  /** Class on the scroll wrapper, e.g. to give it a max height. */
  wrapClassName?: string;
}

/**
 * Styled <table> inside a horizontal scroll wrapper. Put numbers in cells with
 * className="ds-num" (right aligned, tabular figures).
 */
const Table: React.FC<TableProps> = ({ caption, stickyHeader, wrapRef, wrapClassName, className, children, ...rest }) => (
  <div ref={wrapRef} className={cx('ds-table-wrap', wrapClassName)}>
    <table className={cx('ds-table', stickyHeader && 'ds-table--sticky', className)} {...rest}>
      {caption && <caption className="visually-hidden">{caption}</caption>}
      {children}
    </table>
  </div>
);

export default Table;
